import React, { useCallback, useMemo, useState } from "react";
import { GridLegacy, IconButton, TableCell, Tooltip } from "@mui/material";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";
import MainNavbar from "../../components/Navbars/MainNavbar";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { AddCircle, FormatPaint, RemoveCircle } from "@mui/icons-material";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import { _request } from "../../http";
import useJTFilter from "../../components/JamezzTable/V2/useJTFilter";

const endPoint = "core/permissions";

function PermissionForm({ classes }) {
  const [permission, setPermission] = useState(null);
  const { reloadState, updateReloadState } = useReloadState();

  const defaultFilters1 = useMemo(
    () => ({ "permissions.id": { field: "permissions.id", operator: "=", value: permission?.id } }),
    [permission]
  );
  const [textField1, filters1] = useJTFilter("name", defaultFilters1);
  const defaultFilters2 = useMemo(
    () => ({
      "permissions.id": {
        field: "permissions",
        operator: "or",
        value: [
          { field: "permissions.id", has: false },

          { field: "permissions.id", operator: "=", value: permission?.id, has: false },
        ],
      },
    }),
    [permission]
  );
  const [textField2, filters2] = useJTFilter("name", defaultFilters2);

  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Role name"} tKey={"roles.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>{row.name}</TableCell>
      </>
    );
  }, []);

  const renderSelectionActions = useCallback(
    (selected) => {
      return (
        <Tooltip title={<TranslationWrapper tKey={"Remove"} />}>
          <IconButton
            onClick={() => {
              _request(
                "patch",
                `core/permissions/${permission.id}`,
                {
                  roles__id: { detach: Object.keys(selected).map((index) => selected[index]) },
                },
                null
              ).then(() => {
                updateReloadState();
              });
            }}
            style={{ color: "lightcoral" }}
          >
            <RemoveCircle />
          </IconButton>
        </Tooltip>
      );
    },
    [permission]
  );

  const renderSelectionActionsAdd = useCallback(
    (selected) => {
      return (
        <Tooltip title={<TranslationWrapper tKey={"Add"} />}>
          <IconButton
            onClick={() => {
              _request(
                "patch",
                `core/permissions/${permission.id}`,
                {
                  roles__id: { attach: Object.keys(selected).map((index) => selected[index]) },
                },
                null
              ).then(() => {
                updateReloadState();
              });
            }}
            style={{ color: "#07bc0c" }}
          >
            <AddCircle />
          </IconButton>
        </Tooltip>
      );
    },
    [permission]
  );

  const renderRowActions1 = useCallback(
    (row) => {
      return (
        <TableCell align={"right"}>
          <Link to={`/manager/roles/${row.id}/edit`}>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
            >
              <IconButton color={"primary"} simple size={"small"}>
                <Edit />
              </IconButton>
            </Tooltip>
          </Link>
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tKey={"Remove"} />}
          >
            <IconButton
              onClick={(e) => {
                _request(
                  "patch",
                  `core/permissions/${permission?.id}`,
                  {
                    roles__id: { detach: [row.id] },
                  },
                  null
                ).then(() => {
                  updateReloadState();
                });
              }}
              simple
              size={"small"}
              style={{ color: "lightcoral" }}
            >
              <RemoveCircle />
            </IconButton>
          </Tooltip>
        </TableCell>
      );
    },
    [permission]
  );

  const renderRowActions2 = useCallback(
    (row) => {
      return (
        <TableCell align={"right"}>
          <Link to={`/manager/roles/${row.id}/edit`}>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
            >
              <IconButton color={"primary"} onClick={(e) => {}} simple size={"small"}>
                <Edit />
              </IconButton>
            </Tooltip>
          </Link>
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tKey={"Add"} />}
          >
            <IconButton
              onClick={(e) => {
                _request(
                  "patch",
                  `core/permissions/${permission?.id}`,
                  {
                    roles__id: { attach: [row.id] },
                  },
                  null
                ).then(() => {
                  updateReloadState();
                });
              }}
              simple
              size={"small"}
              style={{ color: "#07bc0c" }}
            >
              <AddCircle />
            </IconButton>
          </Tooltip>
        </TableCell>
      );
    },
    [permission]
  );

  return (
    <>
      <MainNavbar paginaTitel={"Permission " + (permission?.name ?? "")} />
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          <FormV2
            endPoint={endPoint}
            mode={"onSubmit"}
            onGetModel={(permission) => {
              setPermission(permission);
            }}
            revalidateMode={"onChange"}
          >
            <GridLegacy container spacing={1}>
              <FormTextTC name={"name"} tDefault={"Permission name"} tKey={"permissions.name"} />
            </GridLegacy>
          </FormV2>
        </GridLegacy>
        <GridLegacy item lg={6} xs={12}>
          {permission ? (
            <>
              {textField1}
              <JamezzTableV2
                checkboxSelection={true}
                dense={true}
                endPoint={"core/roles"}
                filters={filters1}
                headerIcon={<FormatPaint />}
                reloadState={reloadState}
                renderCellsForRow={renderRowCells}
                renderHeaderCells={renderHeaderCells}
                renderRowActions={renderRowActions1}
                renderSelectionActions={renderSelectionActions}
                rowIsEditable={() => false}
                rowIsSelectable={() => true}
                tableTitle={<TranslationWrapper tKey={"Permission has roles"} />}
                uuid={"PermissionForm-roles-123oi123123"}
              />
            </>
          ) : null}
        </GridLegacy>

        <GridLegacy item lg={6} xs={12}>
          {permission ? (
            <>
              {textField2}
              <JamezzTableV2
                checkboxSelection={true}
                dense={true}
                endPoint={"core/roles"}
                filters={filters2}
                headerIcon={<FormatPaint />}
                reloadState={reloadState}
                renderCellsForRow={renderRowCells}
                renderHeaderCells={renderHeaderCells}
                renderRowActions={renderRowActions2}
                renderSelectionActions={renderSelectionActionsAdd}
                rowIsEditable={() => false}
                rowIsSelectable={() => true}
                tableTitle={<TranslationWrapper tKey={"Add new roles"} />}
                uuid={"PermissionForm-roles-askjdij1ikj3"}
              />
            </>
          ) : null}
        </GridLegacy>
      </GridLegacy>
    </>
  );
}

export default withStyles(PermissionForm, vestigingStyle);
